import { createContext, useContext } from 'react';
import type { AccountInfo } from '@azure/msal-browser';

export interface MsalAuthContextValue {
  loggedIn: boolean;
  account: AccountInfo | null;
  showAuthInput: boolean;
  isAuthLoading: boolean;
  isError: boolean;
  isInitialized: boolean;
  setIsError: React.Dispatch<React.SetStateAction<boolean>>;
  loginRedirect: (currentUrl?: string) => Promise<void>;
  loginPopup: () => Promise<void>;
  ssoSilent: (uid: string) => Promise<void>;
  authenticateWithUserId: (userid: string) => void;
  getAccessToken: () => Promise<string>;
  resetTokenTimeout: () => Promise<void>;
  processAuthenticationMode: (mode: string) => void;
}

export const MsalAuthContext = createContext<MsalAuthContextValue | undefined>(undefined);

export function useMsalAuthContext(): MsalAuthContextValue {
  const ctx = useContext(MsalAuthContext);
  if (!ctx) {
    throw new Error('useMsalAuth must be used inside <AuthProvider>');
  }
  return ctx;
}
